import React from "react";
import { Link } from "react-router-dom";
import "./MoreAtJewelboon.css";

const MoreAtJewelboon = () => (
  <div className="more-container">
    <h1>More at <span className="brand-name-gold">Panchali Jewels</span></h1>
    <section className="more-section">
      <div className="coming-soon-icon">✦</div>
      <p className="update-message">
        <strong>Update will come later</strong> for More at <span className="brand-name-gold">Panchali Jewels</span> page.
      </p>
      <p className="sub-message">
        We're working on something special. Stay tuned for exciting new content and features coming soon!
      </p>
      <Link to="/" className="back-home-link">← Back to Home</Link>
    </section>
  </div>
);

export default MoreAtJewelboon;
